import { Component, ComponentRef, Type, ViewChild, ViewContainerRef, effect, signal, Input, ChangeDetectionStrategy } from '@angular/core';

import { IEntityMetaData } from '@app/common-codes/_models/IEntityMetaData';
import { GenericListComponent } from '@app/common-codes/components/list-components/generic-base-list/generic-list.component';
import { Register } from '@app/common-codes/decorators/DependencyInjectionRegistreyDecorators';
import { TabComponentLoader } from '@app/common-codes/services/TabComponentLoader.service';
import { ListTableColumnComponent } from '@app/common-codes/components/list-components/list-table-column/list-table-column.component';
import { ListViewComponent } from '@app/common-codes/components/list-components/list-view/list-view.component';
import { MatwinsSkins } from '@app/common-codes/skins/global.skin';
import { AlertModalService } from '@app/common-codes/services/AlertModalService';
import { IStaticStylesConfig } from '@app/common-codes/skins/_primitives/IStaticStylesConfig';
import { TranslationService } from '@app/common-codes/services/TranslationService';
import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';
import { GenetricDetailComponent } from '@app/common-codes/components/edit-components/generic-detail.component';
import { PointOfServiceDetailComponent } from '../pos-detail/pos-detail.component';
import { PointOfService } from '@app/common-codes/models/matwins-tenant/PointOfService.model';
import { LookupProfile } from '@app/common-codes/services/LookupService';
import { Client } from '@app/common-codes/models/matwins-manager/Client.model';

@Register(PointOfService)
@Component({
  selector: 'app-point-of-service-list',
  templateUrl: './point-of-service-list.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ListViewComponent,
    ListTableColumnComponent,
    TranslatePipe,
    PointOfServiceDetailComponent
  ]
})
export class PointOfServiceListComponent extends GenericListComponent<PointOfService> {
  override Skin = MatwinsSkins.V1 as IStaticStylesConfig;
  override ComponentEntityClass = PointOfService;
  override entityMetaData: IEntityMetaData = new PointOfService().GetType();
  private loadedComponents: { [key: string]: ComponentRef<any> } = {};
  private tabComponentMap: Record<string, Type<any>> = {
    // 'accounts': AccountListComponent 
  };
  override contextMenuItems = []; // pour annuler le context-menu
  // isModalOpen = signal(false); // Renommé pour refléter l'usage (create + edit)
  modalEntity = signal<PointOfService | null>(null);
  @ViewChild('pointOfServiceDetail', { read: PointOfServiceDetailComponent }) pointOfServiceDetail!: PointOfServiceDetailComponent;



  public static override get lookupProfiles(): LookupProfile[] {
    const lookupProfiles: LookupProfile[] = [
      {
        lookupName: "Trucker",
        visibleFields: ["FirstName", "LastName"],
        separatorString: "-",
        additionalProperties: ["Email", "PhoneNumber"],
        sortingField: "FullName",
        filterField: "FK_POS"
      },
      { lookupName: "SmsProvider" }
    ];
    return lookupProfiles;
  }

  constructor(private tabLoader: TabComponentLoader, _alertModalService: AlertModalService, translationService: TranslationService) {
    super();
    this.alertModalService = _alertModalService;
    effect(() => {
      if (!this.mediator) return;
      const lv = this.listView();
      const wanted = this.mediator.selectedLevel1Id();
      if (lv && lv.selectedId() !== wanted) {
        lv.selectedId.set(wanted);
      }
    });
  }

  onSearchInput(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.searchTerm.set(value);
    // Attention :  recherche dans le list-view
    this.listView()?.onSearch(value);
  }

  onTabActivated(tabKey: string) {
    const componentType = this.tabComponentMap[tabKey];
    if (componentType && !this.loadedComponents[tabKey]) {
      const componentRef = this.tabLoader.loadComponent(tabKey, componentType);
      if (componentRef) {
        this.loadedComponents[tabKey] = componentRef;
        const instance = componentRef.instance as GenericListComponent<any>;
        instance.isNested = true;
        const db = this.selectedItem();
        if (db) {
          // if (tabKey === 'database-migrations') {
          // (instance as DataMigrationListComponent).nestedData = db.dataMigrations ?? null;
          //} else if (tabKey === 'database-logs') {
          // (instance as LogListComponent).nestedData = db.logs ?? null;
          //}
        }
      }
    }
  }

  override ngOnInit() {
    super.ngOnInit();

  }

  override ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  override getdetailComponent(): GenetricDetailComponent<PointOfService> | undefined {
    return this.pointOfServiceDetail;
  }

  override openCreateModal() {


    this.componentInstancesService.closeAllComponents();

    const emptyEntity = this.getdetailComponent()?.getEmptyEntity();
    const rootId = this.mediator?.selectedRootId();
    const root: Client = this.mediator?.selectedRoot() as Client;
    if (emptyEntity && root)
      emptyEntity.fK_Tenant = root.relatedTenant?.id || 0;

    this.getdetailComponent()?.editingEntity.set(emptyEntity || null);
    this.selectedItem.set(emptyEntity || null);

    //this.selectedItem.set(null); // Reinitialiser pour la creation
    this.isModalOpen.set(true);
  }

}
